import {Component, inject, OnInit} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  faTriangleExclamation,
  faXmark,
  faChevronRight,
  faPlus,
  faMagnifyingGlass,
  faTrash,
  faExclamationTriangle,
  faUserPlus
} from "@fortawesome/free-solid-svg-icons";
import {Pagination} from "../../../../exam/feature/exam-submissions/exam-submissions.component";
import {MatSnackBar} from "@angular/material/snack-bar";
import {CourseService} from "../../../data-access/course.service";
import _ from "lodash";
import {BreadcrumbNavigation} from "../../../../shared/ui/breadcrumb/breadcrumb.component";

@Component({
  selector: 'subsections-students',
  templateUrl: './subsections-students.component.html',
  standalone: false
})
export class SubsectionsStudentsComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  courseService = inject(CourseService);
  _snackBar = inject(MatSnackBar)
  subsection_id: string | null = null;
  subsection_name: string | null = ''

  currentPagination: Pagination = {
    limit: 15,
    size: 0,
    page: 0,
    start: 0,
    totalcount: 0,
    maxpage: 0
  }

  searchText = ''

  // TODO should include subsection name
  endText = 'Students for ' + this.subsection_name
  breadcrumbNav: BreadcrumbNavigation[] = [{
    text: 'Subsections',
    route: 'dashboard/subsections/list'
  }]

  students: any[] = []
  isLoading = false
  showAddStudent = false
  student_to_add_netid = ''

  confirmDeleteStudent = false
  student_id_to_delete = -1

  ngOnInit() {
    this.route.queryParamMap.subscribe(params => {
      this.subsection_id = params.get('subsection_id');
      this.subsection_name = params.get('subsection_name');
      this.endText = 'Students for ' + this.subsection_name
      if(this.subsection_id != null && !Number.isInteger(this.subsection_id)) {
        this.handleServiceCall()
      }
    });
  }

  handleServiceCall() {
    this.isLoading = true
    this.courseService.getSubsectionStudents(Number(this.subsection_id), this.currentPagination.page, this.currentPagination.limit, this.searchText).subscribe((response) => {
      if(response.success) {
        this.students = response.result.items
        this.currentPagination.totalcount = response.result.count
        this.currentPagination.size = response.result.size
        this.currentPagination.page = response.result.page
        this.currentPagination.limit = response.result.limit
        this.currentPagination.maxpage = Math.floor(response.result.count / response.result.limit)  + 1
      }
      this.isLoading = false
    })
  }

  debounceSearch = _.debounce(() => {
    this.handleServiceCall()
  }, 750)

  seeStudentProfile(email: string) {
    this.router.navigate(['dashboard/profile'], {queryParams: {email: email}});
  }

  addStudentToSubsection() {
    if(this.subsection_id) {
      this.courseService.addStudentToSubsection(Number(this.subsection_id), this.student_to_add_netid).subscribe((response) => {
        if(response.success) {
          this.student_to_add_netid = '';
          this.showAddStudent = false;
          this._snackBar.open(response.msg, 'Dismiss')
          this.handleServiceCall()
        } else {
          this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
        }
      })
    }
  }

  removeStudentFromSubsection() {
    if(this.subsection_id) {
      this.courseService.removeStudentFromSubsection(Number(this.subsection_id), this.student_id_to_delete).subscribe((response) => {
        if(response.success) {
          this.student_id_to_delete = -1;
          this.confirmDeleteStudent = false;
          this._snackBar.open(response.msg, 'Dismiss')
          this.handleServiceCall()
        } else {
          this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
        }
      })
    }
  }

  protected readonly faMagnifyingGlass = faMagnifyingGlass;
  protected readonly faUserPlus = faUserPlus;
  protected readonly faXmark = faXmark;
  protected readonly faPlus = faPlus;
}
